var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "btn btn-outline-secondary",
      class: { disabled: _vm.disabled },
      attrs: { href: _vm.journeyUrl },
      on: { click: _vm.handleClick }
    },
    [
      _c("i", { staticClass: "fas fa-route" }),
      _vm._v(
        " " +
          _vm._s(_vm.resource("JourneyBuilder_Overview_Composer_Button_Text")) +
          "\n"
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }